
export const codeArr = [ {
    code : 
        `Algorithm for Adding Two Numbers:
        1. Input num1
        2. Input num2
        3. sum = num1 + num2
        4. Display sum`
},];